import React, { createContext } from 'react';

const SceneImagePopupContext = createContext();

export default SceneImagePopupContext;